import { Factory, trait } from 'miragejs';

export default Factory.extend({
  enabled: false,
  useExistingPhoto: false,

  withFlowAssign: trait({
    afterCreate(photoPage, server) {
      const flow = server.schema.flows.findBy({ photoPageId: null });

      flow?.update({
        photoPage: photoPage,
      });
    },
  }),
});
